import { Component, h } from 'preact';
import { TcrTags } from './tcr-tags';
import { AppState } from './app-state';
import { I } from 'intl';

class TcrMapInput extends Component
{
    constructor(props)
    {
        super(props);

        this.updatePermission = this.updatePermission.bind(this);
    }

    updatePermission(id, permission)
    {
        this.props.onInput({
            type: 'input',
            target: {
                dataset: {
                    field: this.props.field
                },
                value: {
                    ...this.props.value,
                    [id]: permission
                }
            }
        });
    }

    render()
    {
        let users = (this.props.rows || [])
        .filter(user => {
            if (this.props.readonly && !this.props.value[user.id]) return false;
            return true;
        })
        .map(user => {
            let permission = this.props.value.hasOwnProperty(user.id) ? this.props.value[user.id] : '';
            let input;
            if (this.props.readonly)
            {
                input = <div class="display">{permission == 'rw' ? 'Vollzugriff' : permission == 'r' ? 'Nur lesen' : 'Kein Zugriff'}</div>
            }
            else
            {
                input = [
                    <select value={permission} onInput={(e) => this.updatePermission(user.id, e.target.value)}>
                        <option value="">Kein Zugriff</option>
                        <option value="r">Nur lesen</option>
                        <option value="rw">Vollzugriff</option>
                    </select>,
                    <div class="arrow"></div>
                ];
            }
            return (
                <div class="map-row">
                    <div class="icon" data-icon={this.props.icon}></div>
                    <div class="title">{user.display}</div>
                    <div class="options">
                        {input}
                    </div>
                </div>
            );
        });
        
        return (
            <div class="tcr-map-input" data-readonly={this.props.readonly} >
                {users}
            </div>
        );
    }
}

export { TcrMapInput };
